import React from "react";
import { Icon } from "../Component";
import "./StatCard.css";

/// Compact total / approved / unapproved card used on the Users, Coaches and
/// Consultants pages. Clickable (as a filter) when `onClick` is given.
/// Width grows with the title; height stays fixed.
const StatCard = ({ title, total, approved, unapproved, active, onClick }) => {
  const Tag = onClick ? "button" : "div";
  return (
    <Tag
      type={onClick ? "button" : undefined}
      onClick={onClick}
      className={`stat-card${onClick ? " stat-card--clickable" : ""}${
        active ? " stat-card--active" : ""
      }`}
    >
      <div className="stat-card__head">
        <span className="stat-card__title">{title}</span>
        <span className="stat-card__total">{total ?? 0}</span>
      </div>
      <div className="stat-card__foot">
        <span className="stat-card__pill stat-card__pill--success">
          <Icon name="check"></Icon>
          {approved ?? 0}
        </span>
        <span className="stat-card__pill stat-card__pill--danger">
          <Icon name="cross"></Icon>
          {unapproved ?? 0}
        </span>
      </div>
    </Tag>
  );
};

export const StatCardGroup = ({ children }) => (
  <div className="d-flex flex-wrap" style={{ gap: 12 }}>
    {children}
  </div>
);

export default StatCard;
